import React from "react"
import { useConfig } from "../utils/use-config"

type Props = {
  onClick: () => void
}

const HelpIcon: React.FC<Props> = ({ onClick }) => {
  const { iconText, iconBg, iconTextColor } = useConfig()

  return (
    <button type="button" className={`hw-flex hw-items-center hw-bg-pink-600 hw-text-white hw-p-2 hw-rounded-xl`} onClick={onClick} style={{ backgroundColor: iconBg, color: iconTextColor }}>
      <svg xmlns="http://www.w3.org/2000/svg" className="hw-h-7 hw-w-7 hw-block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
      {iconText &&
        <span className="hw-text-base hw-mx-2">{iconText}</span>
      }
    </button>
  )
}

export default HelpIcon
